var __jsx = React.createElement;
import React from "react";
import { ELSButton } from "components/common/elsevier/Button/Button";
import Elsevier from "components/common/elsevier/Logos/Elsevier";
function Logo(_ref) {
  var name = _ref.name,
    href = _ref.href;
  return /*#__PURE__*/React.createElement(ELSButton, {
    href: href,
    "aria-label": "".concat(name, " homepage")
  }, /*#__PURE__*/React.createElement(Elsevier, null));
}
Logo.defaultProps = {
  name: "Engineering Village",
  href: "/"
};
export default Logo;